import { render } from "./ImagePopup.vue?vue&type=template&id=7a48e97b&scoped=true"
import script from "./ImagePopup.vue?vue&type=script&lang=js"
export * from "./ImagePopup.vue?vue&type=script&lang=js"

import "./ImagePopup.vue?vue&type=style&index=0&id=7a48e97b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a48e97b"]])

export default __exports__